var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsB2BIconReceipt2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.26,
    height: 137.02,
    viewBox: "0 0 86.26 137.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.16,3.4V135.06h5V3.4ZM5.4,5.9H86.66V.9H5.4ZM7.9,134.46V3.4h-5V134.46Zm76.26.6a2.5,2.5,0,0,0,5,0ZM86.66,3.4h2.5A2.5,2.5,0,0,0,86.66.9ZM5.4,3.4V.9A2.5,2.5,0,0,0,2.9,3.4ZM2.9,134.46a2.5,2.5,0,0,0,5,0Z",
    transform: "translate(-2.9 -0.9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2,128.19,4.07,133.3l2.66,4.24,8.13-5.12ZM23,133.3l-8.13-5.11-2.66,4.23,8.13,5.12Zm5.47-5.11-8.13,5.11L23,137.54l8.13-5.12Zm10.79,5.11-8.13-5.11-2.66,4.23,8.12,5.12Zm5.46-5.11-8.13,5.11,2.67,4.24,8.12-5.12ZM55.5,133.3l-8.13-5.11-2.66,4.23,8.12,5.12ZM61,128.19l-8.13,5.11,2.67,4.24,8.12-5.12Zm10.79,5.11-8.13-5.11L61,132.42l8.12,5.12Zm5.46-5.11-8.13,5.11,2.67,4.24,8.12-5.12ZM88,133.3l-8.13-5.11-2.66,4.23,8.12,5.12Zm-83.93,0a2.5,2.5,0,0,0,2.66,4.24Zm9.46-3,1.33-2.12a2.5,2.5,0,0,0-2.66,0Zm8.13,5.11-1.33,2.12a2.5,2.5,0,0,0,2.66,0Zm8.13-5.11,1.33-2.12a2.5,2.5,0,0,0-2.66,0Zm8.13,5.11-1.34,2.12a2.52,2.52,0,0,0,2.67,0ZM46,130.31l1.33-2.12a2.5,2.5,0,0,0-2.66,0Zm8.12,5.11-1.33,2.12a2.52,2.52,0,0,0,2.67,0Zm8.13-5.11,1.33-2.12a2.5,2.5,0,0,0-2.66,0Zm8.13,5.11-1.34,2.12a2.52,2.52,0,0,0,2.67,0Zm8.12-5.11,1.33-2.12a2.5,2.5,0,0,0-2.66,0Zm6.79,7.23A2.51,2.51,0,0,0,88,133.3Z",
    transform: "translate(-2.9 -0.9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4,18.09H86.66v-5H5.4Zm81.26,0a2.5,2.5,0,0,0,0-5Zm-81.26-5a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-2.9 -0.9)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.48,
    y: 96,
    width: 39.9,
    height: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.48,
    y: 32.53,
    width: 39.9,
    height: 5,
    fill: "red"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.48,
    y: 47.38,
    width: 39.9,
    height: 5,
    fill: "red"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.91,
    y: 47.38,
    width: 8.32,
    height: 5,
    fill: "red"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.48,
    y: 61.03,
    width: 21.99,
    height: 5,
    fill: "red"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 62.91,
    y: 61.03,
    width: 8.32,
    height: 5,
    fill: "red"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 62.91,
    y: 32.53,
    width: 8.32,
    height: 5,
    fill: "red"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 106.51,
    width: 39.9,
    height: 5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.48,
    y: 106.51,
    width: 10.74,
    height: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsB2BIconReceipt2);
export default __webpack_public_path__ + "static/media/ws-b2b-icon-receipt-2.7f831ebfebd432490b2dabf99636c2d0.svg";
export { ForwardRef as ReactComponent };